import React from 'react';
import { Modal } from 'react-bootstrap';
import styles from './WarningModal.css';

class WarningModal extends React.Component {
  render() {
    return (
      <Modal
        backdrop="static"
        onHide={this.props.onHide}
        show
        dialogClassName={`${styles.dialog} modal-dialog`}
      >
        <Modal.Header>
          <Modal.Title className={styles['title-modal']}>
            {this.props.title} <b>{this.props.titleBold}</b>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>
            <div className={styles['image-dialog']}>
              <img src={this.props.imageSrc} />
            </div>
            <div className={`${styles['text-dialog']} ${styles['text-bold']}`}>
              {this.props.subTitle}
            </div>
            <div className={`${styles['text-dialog']}`}>{this.props.text}</div>
            <div className={`text-center`}>
              <button
                type="button"
                className={`${styles['main-btn-dialog']} btn btn-primary`}
                onClick={this.props.onClick}
              >
                {this.props.buttonText}
              </button>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div>
            <button
              type="button"
              className="btn btn-default"
              onClick={this.props.onHide}
            >
              Close
            </button>
          </div>
        </Modal.Footer>
      </Modal>
    );
  }
}

export default WarningModal;
